import * as Telecom from '@servicetitan/telecom-rtcs-client';
import log from '../../lib/log';
import { serviceState } from '../../lib/state';

async function handleQueueDeleted(event: Telecom.QueueDeletedEvent) {
  log('rtcs:queue:deleted:' + event.queueName, event);

  serviceState.queues = [
    ...serviceState.queues.filter((q) => q.id !== event.queueId),
  ];
}

export default handleQueueDeleted;
